module.exports = __webpack_public_path__ + "static/media/mail-card.c7807cdc.png";